/**
 * Navigation Update Utilities
 * 
 * This module provides utilities to trigger navigation updates
 * when authentication or subscription state changes.
 */

import { triggerSubscriptionUpdate } from './subscriptionUtils';

// Custom event for navigation updates
export const NAVIGATION_UPDATE_EVENT = 'navigation-update';

/**
 * Trigger a navigation update
 * This forces all navigation components to re-evaluate their configuration
 */
export const triggerNavigationUpdate = () => {
  console.log('🔄 Triggering navigation update...');
  
  // Trigger subscription update first (which will cascade to navigation updates)
  triggerSubscriptionUpdate();
  
  // Also trigger a specific navigation update event
  window.dispatchEvent(new CustomEvent(NAVIGATION_UPDATE_EVENT));
};

/**
 * Set up a listener for navigation updates
 * @param {Function} callback - Function to call when navigation should update
 * @returns {Function} - Cleanup function to remove the listener
 */
export const onNavigationUpdate = (callback) => {
  const handleNavigationUpdate = () => {
    console.log('📋 Navigation update event received');
    callback();
  };

  window.addEventListener(NAVIGATION_UPDATE_EVENT, handleNavigationUpdate);
  
  // Return cleanup function
  return () => {
    window.removeEventListener(NAVIGATION_UPDATE_EVENT, handleNavigationUpdate);
  };
};

/**
 * Trigger navigation update after successful authentication
 * This should be called after login, logout, or role changes
 */
export const triggerNavigationUpdateAfterAuth = () => {
  console.log('🚀 Triggering navigation update after authentication change...');
  
  // Small delay to ensure localStorage is updated
  setTimeout(() => {
    triggerNavigationUpdate();
  }, 100);
};

export default {
  triggerNavigationUpdate,
  triggerNavigationUpdateAfterAuth,
  onNavigationUpdate,
  NAVIGATION_UPDATE_EVENT
};